module.exports = __webpack_public_path__ + "static/img/right_1_3.acb9baf3.jpg";